// Copyright (c) 2026 Query Health Inc. All rights reserved.
// Author: Anmol Rajpal <anmol@quantinohealth.com>
// Licensed under a Commercial License. See LICENSE for terms.

// Loud, persistent banner shown while a QH/Quantino operator is acting as a
// client org. This is the guardrail for the no-confirm instant-switch UX — it
// keeps the active org unmistakable so an operator never acts on the wrong one.
// Renders nothing for client staff or an operator with no org selected.

import { useTranslation } from 'react-i18next'
import { Eye, X } from 'lucide-react'
import { useAuth } from '@/context/auth-context'

export default function ActingAsBanner() {
  const { t } = useTranslation()
  const { actingAsOrg, setActingAsOrg } = useAuth()

  if (!actingAsOrg) return null

  return (
    <div
      role="status"
      className="sticky top-0 z-20 flex items-center justify-center gap-2 px-4 py-2 text-sm font-semibold text-amber-950 bg-amber-400 border-b border-amber-500 shadow-sm"
    >
      <Eye className="h-4 w-4 shrink-0" aria-hidden />
      <span className="truncate">
        {t('orgSwitcher.operatingAs', { org: actingAsOrg.displayName })}
      </span>
      <button
        onClick={() => setActingAsOrg(null)}
        className="ml-2 inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-xs font-semibold text-amber-950 hover:bg-amber-500/40 transition-colors"
      >
        <X className="h-3.5 w-3.5" aria-hidden />
        {t('orgSwitcher.exit')}
      </button>
    </div>
  )
}
